import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Squiggle } from "./Doodles";
import { FacebookIcon, InstagramIcon, WhatsAppIcon } from "./Icons";
import { NAV, SITE } from "@/lib/site";

export const SocialLinks = ({ prefix = "footer" }) => (
  <div className="flex gap-3">
    {[
      { href: SITE.whatsappLink, Icon: WhatsAppIcon, label: "واتساب", id: "whatsapp" },
      { href: SITE.facebook, Icon: FacebookIcon, label: "فيسبوك", id: "facebook" },
      { href: SITE.instagram, Icon: InstagramIcon, label: "إنستجرام", id: "instagram" },
    ].map(({ href, Icon, label, id }) => (
      <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`${prefix}-${id}-link`}
        className="grid h-12 w-12 place-items-center rounded-2xl border border-purple-500/30 text-[var(--km-lilac)] transition-[transform,background-color,color] duration-200 hover:-rotate-6 hover:bg-[var(--km-purple)] hover:text-white">
        <Icon className="h-5 w-5" />
      </a>
    ))}
  </div>
);

export const Footer = () => (
  <footer className="relative mt-24 overflow-hidden border-t border-purple-500/20 bg-black" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
      <div className="space-y-4">
        <Logo />
        <p className="max-w-xs text-sm leading-relaxed text-purple-200/80">استوديو موشن جرافيك بيحوّل فكرة براندك لإعلان متحرك يخطف العين.</p>
        <SocialLinks />
      </div>
      <nav aria-label="روابط الفوتر" className="grid grid-cols-2 gap-2 text-sm">
        {[...NAV, { to: "/create-ad", label: "اعمل إعلانك", id: "create-ad" }].map((n) => (
          <Link key={n.to} to={n.to} data-testid={`footer-${n.id}-link`} className="font-head text-[var(--km-lilac)] transition-colors hover:text-white">
            {n.label}
          </Link>
        ))}
      </nav>
      <div className="space-y-2 text-sm text-purple-200/80">
        <p className="font-head text-white">كلمنا واتساب</p>
        <a href={SITE.whatsappLink} target="_blank" rel="noopener noreferrer" dir="ltr" className="font-head block text-2xl font-bold text-[var(--km-cyan)]" data-testid="footer-phone-link">
          {SITE.whatsapp}
        </a>
        <Squiggle className="mt-4 h-6 w-40" color="#7D2CC6" width={4} />
      </div>
    </div>
    <p className="border-t border-purple-500/10 py-4 text-center text-xs text-purple-300/60">© {new Date().getFullYear()} خرابيش موشن. كل الحقوق محفوظة.</p>
  </footer>
);
